/**
 * @generated SignedSource<<7b69d589931e4a2a3771c8fb687a9aba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubIssueTitle$data = {
  readonly number: number;
  readonly repository: {
    readonly name: string;
    readonly owner: {
      readonly login: string;
    };
  };
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"SubIssueTitle_TitleValue" | "SubIssueTypeIndicator" | "SubIssuesCompletionPill">;
  readonly " $fragmentType": "SubIssueTitle";
};
export type SubIssueTitle$key = {
  readonly " $data"?: SubIssueTitle$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubIssueTitle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubIssueTitle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "login",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubIssueTitle_TitleValue"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubIssueTypeIndicator"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubIssuesCompletionPill"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "4a12d7a3f9c2795b66075990458d0bba";

export default node;
